import { Dispatch, SetStateAction } from "react";
import { StateCreator } from "zustand";

export const createFieldSetStateAction =
  <T, K extends keyof T>(set: Parameters<StateCreator<T>>[0], key: K): Dispatch<SetStateAction<T[K]>> =>
  (newVal) => {
    const update: Partial<T> = {};
    if (newVal instanceof Function) {
      set((prev) => {
        update[key] = newVal(prev[key]);
        return update;
      });
    } else {
      update[key] = newVal;
      set(update);
    }
  };
